var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5038_449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 21.0011L26.964 38.1616C27.272 38.3891 27.636 38.5011 28 38.5011C28.364 38.5011 28.728 38.3891 29.036 38.1616L56 21.0011L29.05 0.351078C28.427 -0.114422 27.573 -0.114422 26.95 0.351078L0 21.0011Z",
    fill: "#177BA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5 0H10.5C8.5715 0 7 1.5715 7 3.5V42C7 42.966 7.784 43.75 8.75 43.75H47.25C48.216 43.75 49 42.966 49 42V3.5C49 1.5715 47.432 0 45.5 0Z",
    fill: "#ECEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 10.5H40.25C41.216 10.5 42 9.716 42 8.75C42 7.784 41.216 7 40.25 7H15.75C14.784 7 14 7.784 14 8.75C14 9.716 14.784 10.5 15.75 10.5Z",
    fill: "#90A4AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.25 14H15.75C14.784 14 14 14.784 14 15.75C14 16.716 14.784 17.5 15.75 17.5H40.25C41.216 17.5 42 16.716 42 15.75C42 14.784 41.216 14 40.25 14Z",
    fill: "#90A4AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.75 21H15.75C14.784 21 14 21.784 14 22.75C14 23.716 14.784 24.5 15.75 24.5H29.75C30.716 24.5 31.5 23.716 31.5 22.75C31.5 21.784 30.716 21 29.75 21Z",
    fill: "#90A4AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.036 38.1605C28.728 38.388 28.364 38.5 28 38.5C27.636 38.5 27.272 38.388 26.964 38.1605L0 21V52.5C0 54.432 1.568 56 3.5 56H52.5C54.432 56 56 54.432 56 52.5V21L29.036 38.1605Z",
    fill: "#056E9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5 56H3.5C1.5365 56 0 54.4635 0 52.5C0 51.9435 0.266 51.4185 0.714 51.0895L26.964 33.5895C27.272 33.362 27.636 33.25 28 33.25C28.364 33.25 28.728 33.362 29.036 33.5895L55.286 51.0895C55.734 51.4185 56 51.9435 56 52.5C56 54.4635 54.4635 56 52.5 56Z",
    fill: "#1179A8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5038_449"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSvg);
export default __webpack_public_path__ + "static/media/EmailSvg.e5576f9c46e375ecaf832cb68b6e1596.svg";
export { ForwardRef as ReactComponent };